export default __webpack_public_path__ + "static/media/news-2.11b3a9d0.jpg";